export enum PartyUserState {
  AWAKE = 'AWAKE',
  ASLEEP = 'ASLEEP',
}
